import { render, staticRenderFns } from "./CustomizeEdittopic.vue?vue&type=template&id=56cc88fa"
import script from "./CustomizeEdittopic.vue?vue&type=script&lang=js"
export * from "./CustomizeEdittopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports